import React from "react";
import BaseField from "./BaseField"
import DatePicker from "react-datepicker";
import moment from "moment";

export default function TextField(props){
  const { action, resource, name, label, value, col, onChange } = props;
  
  return(
    <BaseField action={action} resource={resource} name={name} label={label} value={value && moment(value).format("MM/DD/YYYY")} col={col}>
      <DatePicker selected={value ? moment(value) : null} onChange={onChange} className="form-control" placeholderText="MM/DD/YYYY" />
    </BaseField>
  )
}